import { useContext, useState } from 'react';
import MenuItemMobile from './MenuItemMobile';
import { UserContext } from '@context/createContext';
import { Link, useNavigate } from 'react-router-dom';
import ToastError from '../modules/toast/ToastError';
import { deleteAllCookies } from '@helper/functions';
import { sidebarMobile } from '@/constants/sidebarData';
import ConfirmationModal from '@core/ConfirmationModal';

export default function SidebarMobile() {
  const {
    user: { userType, realState },
  } = useContext(UserContext);

  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="lg:hidden grid grid-cols-5 max-lg:gap-16 max-sm:gap-0 h-[72px] w-full bg-white px-4 py-2 border-t-[1px] border-text-normal/20 fixed bottom-0 left-0 right-0 z-20">
        {userType == 'agent' &&
          sidebarMobile
            .filter((item) => item.agent === true)
            .map((i) => <MenuItemMobile key={i.id} {...i} open={open} setOpen={setOpen} realState={realState} />)}

        {userType == 'realStateOwner' &&
          sidebarMobile
            .filter((item) => item.rsOwner === true)
            .map((i) => <MenuItemMobile key={i.id} {...i} open={open} setOpen={setOpen} realState={realState} />)}
      </div>
      {open && <MenuFilterMobile setOpen={setOpen} />}
    </>
  );
}

function MenuFilterMobile({ setOpen }) {
  const {
    realEstate,
    clearUser,
    user: { _id, userType, realState },
  } = useContext(UserContext);

  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);

  const logoutHandler = async () => {
    await deleteAllCookies();
    await clearUser();
    navigate('/login', { replace: true });
  };

  const navigateSubdomain = () => {
    if (userType == 'agent') {
      if (!realEstate.subdomain || !realEstate.color) {
        ToastError({ content: 'اطلاعات املاک شما کامل نیست' });
      } else {
        window.open(`/${realEstate.subdomain}/list-agents/agent/${_id}`, '_blank', 'noopener,noreferrer');
      }
    } else {
      if (!realEstate.subdomain) {
        ToastError({ content: 'برای سایت املاک هنوز آدرسی ثبت نشده' });
        navigate('settings#SiteSubdomain');
      } else if (!realEstate.color) {
        ToastError({ content: 'برای سایت املاک هنوز رنگ سازمانی ثبت نشده' });
        navigate('settings#OrganizationalColor');
      } else {
        window.open(`/${realEstate.subdomain}`, '_blank', 'noopener,noreferrer');
      }
    }
  };

  return (
    <>
      <div
        className={`fixed inset-0 z-30 flex flex-col bg-white h-[calc(100dvh-72px)] w-screen p-5 modalFilter transition-all`}
      >
        <div className="w-full flex fle-row items-center justify-between border-b-[1px] border-b-light-grey pb-4">
          <p className="font-medium text-sm text-text-hard">فیلتر ها</p>
          <p
            onClick={() => {
              setOpen(false);
            }}
            className="text-text-normal text-sm"
          >
            بستن
          </p>
        </div>
        <div className="flex flex-col justify-between h-full mt-5 w-full">
          <div className="flex flex-col gap-3">
            {realState ? (
              <button
                className={`${
                  location.pathname.includes('/customers')
                    ? 'text-primary border-primary'
                    : 'text-text-normal border-light-grey'
                } flex flex-col rounded-md bg-white border-[1px] shadow-sm`}
              >
                <div className="flex flex-row items-center p-4 relative">
                  <Link
                    onClick={() => setOpen(false)}
                    to={`/customers`}
                    className="absolute w-full h-full right-0 top-0 rounded-md"
                  />
                  <div className="flex flex-row items-center gap-2 w-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        opacity="0.24"
                        d="M9.92154 2.57125C11.2077 1.80958 12.7923 1.80958 14.0785 2.57125L18.9215 5.43932C20.2077 6.20099 21 7.6086 21 9.13192V14.8681C21 16.3914 20.2077 17.799 18.9215 18.5607L14.0785 21.4288C12.7923 22.1904 11.2077 22.1904 9.92154 21.4288L5.07846 18.5607C3.7923 17.799 3 16.3914 3 14.8681V9.13192C3 7.6086 3.7923 6.20099 5.07846 5.43932L9.92154 2.57125Z"
                        fill="currentColor"
                      />
                      <path
                        d="M9.92155 21.4286C11.2077 22.1903 12.7923 22.1903 14.0785 21.4286L18.301 18.928C17.0431 16.698 14.6924 15.1978 12 15.1978C9.30764 15.1978 6.95688 16.698 5.69897 18.928L9.92155 21.4286Z"
                        fill="currentColor"
                      />
                      <circle cx="3" cy="3" r="3" transform="matrix(1 0 0 -1 9 13)" fill="currentColor" />
                    </svg>
                    <p className="text-base">لیست مشتریان</p>
                  </div>
                </div>
              </button>
            ) : (
              <button
                disabled={true}
                className={`${
                  location.pathname.includes('/customers')
                    ? 'text-primary border-primary'
                    : 'text-text-normal border-light-grey'
                } flex flex-col disabled:opacity-50 rounded-md bg-white border-[1px] shadow-sm`}
              >
                <div className="flex flex-row items-center p-4 relative">
                  <div className="flex flex-row items-center gap-2 w-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        opacity="0.24"
                        d="M9.92154 2.57125C11.2077 1.80958 12.7923 1.80958 14.0785 2.57125L18.9215 5.43932C20.2077 6.20099 21 7.6086 21 9.13192V14.8681C21 16.3914 20.2077 17.799 18.9215 18.5607L14.0785 21.4288C12.7923 22.1904 11.2077 22.1904 9.92154 21.4288L5.07846 18.5607C3.7923 17.799 3 16.3914 3 14.8681V9.13192C3 7.6086 3.7923 6.20099 5.07846 5.43932L9.92154 2.57125Z"
                        fill="currentColor"
                      />
                      <path
                        d="M9.92155 21.4286C11.2077 22.1903 12.7923 22.1903 14.0785 21.4286L18.301 18.928C17.0431 16.698 14.6924 15.1978 12 15.1978C9.30764 15.1978 6.95688 16.698 5.69897 18.928L9.92155 21.4286Z"
                        fill="currentColor"
                      />
                      <circle cx="3" cy="3" r="3" transform="matrix(1 0 0 -1 9 13)" fill="currentColor" />
                    </svg>
                    <p className="text-base">لیست مشتریان</p>
                  </div>
                </div>
              </button>
            )}
            {userType !== 'agent' && (
              <div
                className={`${
                  location.pathname.includes('/subscription')
                    ? 'text-primary border-primary'
                    : 'text-text-normal border-light-grey'
                } flex flex-col rounded-md bg-white border-[1px] shadow-sm`}
              >
                <div className="flex flex-row items-center p-4 relative">
                  <Link
                    onClick={() => setOpen(false)}
                    to={`/subscription`}
                    className="absolute w-full h-full right-0 top-0 rounded-md"
                  />
                  <div className="flex flex-row items-center gap-2 w-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        opacity="0.24"
                        d="M16.7702 18.98H7.23024C6.81024 18.98 6.43024 18.71 6.29024 18.32L2.13024 6.66998C1.80024 5.73998 2.86024 4.94998 3.65024 5.51998L7.65024 8.37998C8.18024 8.75998 8.94024 8.52998 9.17024 7.91998L11.0602 2.87998C11.3802 2.00998 12.6102 2.00998 12.9302 2.87998L14.8202 7.91998C15.0502 8.53998 15.8002 8.75998 16.3402 8.37998L20.3402 5.51998C21.1402 4.94998 22.1902 5.74998 21.8602 6.66998L17.7002 18.32C17.5702 18.71 17.1902 18.98 16.7702 18.98Z"
                        fill="currentColor"
                      />
                      <path
                        opacity="0.8"
                        d="M17 22H7C6.59 22 6.25 21.66 6.25 21.25C6.25 20.84 6.59 20.5 7 20.5H17C17.41 20.5 17.75 20.84 17.75 21.25C17.75 21.66 17.41 22 17 22Z"
                        fill="currentColor"
                      />
                      <path
                        opacity="0.8"
                        d="M14.5 14.75H9.5C9.09 14.75 8.75 14.41 8.75 14C8.75 13.59 9.09 13.25 9.5 13.25H14.5C14.91 13.25 15.25 13.59 15.25 14C15.25 14.41 14.91 14.75 14.5 14.75Z"
                        fill="currentColor"
                      />
                    </svg>
                    <p className="text-base">مدیریت اشتراک</p>
                  </div>
                </div>
              </div>
            )}
            {userType != 'agent' && (
              <div
                className={`${
                  location.pathname.includes('/agents/invations')
                    ? 'text-primary border-primary'
                    : 'text-text-normal border-light-grey'
                } flex flex-col rounded-md bg-white border-[1px] shadow-sm`}
              >
                <div className="flex flex-row items-center p-4 relative">
                  <Link
                    onClick={() => setOpen(false)}
                    to={`/agents/invations`}
                    className="absolute w-full h-full right-0 top-0 rounded-md"
                  />
                  <div className="flex flex-row items-center gap-2 w-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 12V18"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        opacity="0.8"
                        d="M20 8V7C20 5.34315 18.6569 4 17 4H14.1975C13.5294 4 12.8805 3.77702 12.3535 3.3664L11.4131 2.6336C10.8862 2.22298 10.2372 2 9.56917 2H7C5.34315 2 4 3.34315 4 5V8H20Z"
                        fill="currentColor"
                      />
                      <path
                        opacity="0.24"
                        d="M20.5261 8H3.47403C2.20074 8 1.25163 9.17404 1.51843 10.4191L3.32251 18.8381C3.71771 20.6824 5.34757 22 7.23372 22H16.7664C18.6525 22 20.2824 20.6824 20.6776 18.8381L22.4817 10.4191C22.7485 9.17403 21.7994 8 20.5261 8Z"
                        fill="currentColor"
                      />
                      <g opacity="0.8">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V14.25H15C15.4142 14.25 15.75 14.5858 15.75 15C15.75 15.4142 15.4142 15.75 15 15.75L12.75 15.75V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V15.75H9C8.58579 15.75 8.25 15.4142 8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H11.25V12C11.25 11.5858 11.5858 11.25 12 11.25Z"
                          fill="currentColor"
                        />
                      </g>
                    </svg>
                    <p className="text-base">مدیریت درخواست ها</p>
                  </div>
                </div>
              </div>
            )}
            <button
              className={`${
                location.pathname.includes('/settings')
                  ? 'text-primary border-primary'
                  : 'text-text-normal border-light-grey'
              } flex flex-col rounded-md bg-white border-[1px] shadow-sm`}
            >
              {realState ? (
                <Link
                  onClick={() => setOpen(false)}
                  to={`/settings`}
                  className="flex flex-row items-center p-4 gap-2 w-full"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      opacity="0.24"
                      d="M12.9545 3H11.0455C9.99109 3 9.13635 3.80589 9.13635 4.8C9.13635 5.93761 7.91917 6.66087 6.92 6.11697L6.81852 6.06172C5.90541 5.56467 4.73782 5.85964 4.21064 6.72057L3.25609 8.27942C2.72891 9.14034 3.04176 10.2412 3.95487 10.7383C4.95451 11.2824 4.95451 12.7176 3.95487 13.2617C3.04176 13.7588 2.72891 14.8597 3.25609 15.7206L4.21064 17.2794C4.73782 18.1404 5.90541 18.4353 6.81851 17.9383L6.92 17.883C7.91917 17.3391 9.13635 18.0624 9.13635 19.2C9.13635 20.1941 9.99109 21 11.0455 21H12.9545C14.0089 21 14.8636 20.1941 14.8636 19.2C14.8636 18.0624 16.0808 17.3391 17.08 17.883L17.1815 17.9383C18.0946 18.4353 19.2622 18.1403 19.7894 17.2794L20.7439 15.7206C21.2711 14.8596 20.9582 13.7588 20.0451 13.2617C19.0455 12.7176 19.0455 11.2824 20.0451 10.7383C20.9582 10.2412 21.2711 9.14036 20.7439 8.27943L19.7894 6.72058C19.2622 5.85966 18.0946 5.56468 17.1815 6.06174L17.08 6.11698C16.0808 6.66088 14.8636 5.93762 14.8636 4.8C14.8636 3.80589 14.0089 3 12.9545 3Z"
                      fill="currentColor"
                    />
                    <circle opacity="0.8" cx="12" cy="12" r="3" fill="currentColor" />
                  </svg>
                  <p className="text-base">تنظیمات</p>
                </Link>
              ) : (
                <button disabled={true} className="disabled:opacity-50 flex flex-row items-center p-4 gap-2 w-full">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      opacity="0.24"
                      d="M12.9545 3H11.0455C9.99109 3 9.13635 3.80589 9.13635 4.8C9.13635 5.93761 7.91917 6.66087 6.92 6.11697L6.81852 6.06172C5.90541 5.56467 4.73782 5.85964 4.21064 6.72057L3.25609 8.27942C2.72891 9.14034 3.04176 10.2412 3.95487 10.7383C4.95451 11.2824 4.95451 12.7176 3.95487 13.2617C3.04176 13.7588 2.72891 14.8597 3.25609 15.7206L4.21064 17.2794C4.73782 18.1404 5.90541 18.4353 6.81851 17.9383L6.92 17.883C7.91917 17.3391 9.13635 18.0624 9.13635 19.2C9.13635 20.1941 9.99109 21 11.0455 21H12.9545C14.0089 21 14.8636 20.1941 14.8636 19.2C14.8636 18.0624 16.0808 17.3391 17.08 17.883L17.1815 17.9383C18.0946 18.4353 19.2622 18.1403 19.7894 17.2794L20.7439 15.7206C21.2711 14.8596 20.9582 13.7588 20.0451 13.2617C19.0455 12.7176 19.0455 11.2824 20.0451 10.7383C20.9582 10.2412 21.2711 9.14036 20.7439 8.27943L19.7894 6.72058C19.2622 5.85966 18.0946 5.56468 17.1815 6.06174L17.08 6.11698C16.0808 6.66088 14.8636 5.93762 14.8636 4.8C14.8636 3.80589 14.0089 3 12.9545 3Z"
                      fill="currentColor"
                    />
                    <circle opacity="0.8" cx="12" cy="12" r="3" fill="currentColor" />
                  </svg>
                  <p className="text-base">تنظیمات</p>
                </button>
              )}
            </button>
            {/* <button
              className={`${
                location.pathname.includes("/help")
                  ? "text-primary border-primary"
                  : "text-text-normal border-light-grey"
              } flex flex-col rounded-md bg-white border-[1px] shadow-sm`}
            >
              <Link onClick={() => setOpen(false)} to={`/help`} className="flex flex-row items-center p-4 gap-2 w-full">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    opacity="0.24"
                    d="M18.3801 12.84V17.77C18.3801 19.04 17.3901 20.4 16.2001 20.8L13.0101 21.86C12.4501 22.05 11.5401 22.05 10.9901 21.86L7.80012 20.8C6.60012 20.4 5.62012 19.04 5.62012 17.77L5.63012 12.84L10.0501 15.72C11.1301 16.43 12.9101 16.43 13.9901 15.72L18.3801 12.84Z"
                    fill="currentColor"
                  />
                  <path
                    opacity="0.8"
                    d="M19.9795 6.46L13.9895 2.53C12.9095 1.82 11.1295 1.82 10.0495 2.53L4.02953 6.46C2.09953 7.71 2.09953 10.54 4.02953 11.8L5.62953 12.84L10.0495 15.72C11.1295 16.43 12.9095 16.43 13.9895 15.72L18.3795 12.84L19.7495 11.94V15C19.7495 15.41 20.0895 15.75 20.4995 15.75C20.9095 15.75 21.2495 15.41 21.2495 15V10.08C21.6495 8.79 21.2395 7.29 19.9795 6.46Z"
                    fill="currentColor"
                  />
                </svg>
                <p className="text-base">راهنما</p>
              </Link>
            </button> */}
            <button
              disabled={realState ? false : true}
              className={` disabled:opacity-50 text-primary flex flex-col rounded-md border-primary bg-lighter-primary-10 border-[1px] shadow-sm`}
            >
              <div
                // onClick={navigateSubdomain}
                className="flex flex-row items-center p-4 gap-2 w-full"
              >
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5 16.9498H6.71C3.34 16.9498 2.5 16.1098 2.5 12.7398V6.73979C2.5 3.36979 3.34 2.52979 6.71 2.52979H17.24C20.61 2.52979 21.45 3.36979 21.45 6.73979"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.5 21.4702V16.9502"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2.5 12.9502H10.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.24023 21.4702H10.5002"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22.5003 12.7998V18.5098C22.5003 20.8798 21.9103 21.4698 19.5403 21.4698H15.9903C13.6203 21.4698 13.0303 20.8798 13.0303 18.5098V12.7998C13.0303 10.4298 13.6203 9.83984 15.9903 9.83984H19.5403C21.9103 9.83984 22.5003 10.4298 22.5003 12.7998Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.7441 18.25H17.7531"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p>نمایش سایت من</p>
              </div>
            </button>
            <button className={`text-error flex flex-col rounded-md border-error bg-[#F9E5E9] border-[1px] shadow-sm`}>
              <div
                onClick={(e) => {
                  setOpenModal(true);
                }}
                className="flex flex-row items-center p-4 gap-2 w-full"
              >
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.6172 8.81979C17.2555 4.61979 15.0972 2.90479 10.3722 2.90479H10.2205C5.00552 2.90479 2.91719 4.99312 2.91719 10.2081V17.8148C2.91719 23.0298 5.00552 25.1181 10.2205 25.1181H10.3722C15.0622 25.1181 17.2205 23.4265 17.6055 19.2965"
                    stroke="#E11640"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.5007 14H23.7773"
                    stroke="#E11640"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21.1757 10.0918L25.084 14.0001L21.1757 17.9085"
                    stroke="#E11640"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="text-base">خروج از داشبورد</p>
              </div>
            </button>
          </div>
        </div>
      </div>
      {openModal && (
        <ConfirmationModal
          setShowModal={setOpenModal}
          handler={() => setOpenModal(false)}
          title="خروج از حساب کاربری"
          desc="آیا از خروج از حساب کاربری خود اطمینان دارید؟"
          btnText="تأیید خروج"
        />
      )}
    </>
  );
}
